import { PostType } from '%__generated__/types';
import { PostMutationsOptions } from '%screens/posts/new/mutations/postMutations';
import { GetPostDataQuery } from '../PostData/__generated__/postData.generated';

export type PostToEditData = Pick<
	GetPostDataQuery['post'],
	| 'id'
	| 'content'
	| 'mediaFiles'
	| 'informationFeedId'
	| 'selectedUsers'
	| 'status'
	| 'publishAt'
	| 'publishedAt'
	| 'hasPublicationError'
>;

type FeedPostParams = {
	type: PostType.Feed;
	selectedUsers?: string[];
};

type CommunityPostParams = {
	type: PostType.Information;
	communityGroupUuid: string;
	informationFeedId?: never;
};

type InformationPostParams = {
	type: PostType.Information;
	informationFeedId: string;
	communityGroupUuid?: never;
};

export type PostTypeParams = FeedPostParams | CommunityPostParams | InformationPostParams;

export type PostFormProps = {
	postTypeParams: PostTypeParams;
	postToEdit?: PostToEditData;
	onSaveStarted?: () => unknown;
	onClose?: () => unknown;
	mutationOptions?: PostMutationsOptions;
};
